import { ExportEnum } from './enums';

export const COLOR_PALETTE_GENERATOR_URL = 'color/palette-generator';
export const ACCEPTED_FORMATS = ['png', 'jpg', 'jpeg', 'heic', 'heif'];
export const MIN_COLORS = 2;
export const MAX_COLORS = 10;

export const exportChoices = [
  {
    title: ExportEnum.COPY_LINK,
    svgInactiveIcon: 'https://cdn140.picsart.com/86976455646305649439.svg',
  },
  {
    title: ExportEnum.PDF,
    svgInactiveIcon: 'https://cdn140.picsart.com/57201547810591064999.svg',
  },
  {
    title: ExportEnum.QR_CODE,
    svgInactiveIcon: 'https://cdn140.picsart.com/89675164631885515342.svg',
  },
];

export const defaultPosition = {
  x: 0,
  y: 0,
};

export const SvgIcons = {
  noImageIcon: 'https://cdn140.picsart.com/16356471173663273258.svg',
  fileCornerIcon: 'https://cdn140.picsart.com/15203599943012610577.svg',
};
